<div class="verify-blk" *ngIf="showVerifyCode">
    <mat-card class="p-4 text-center shadow-none">
    <h4
        class="form-title text-center  my-4"
        translate
        >pages.login.verification
    </h4>
    <h3 class="text-center w-75 mx-auto " translate>Hello {{userName}}</h3>
    <h4 class="form-field-tile mx-5 text-center" translate>
        A code has been sent to registered Email
        <!--<span> {{ notificationMethod }}</span>-->
    </h4>
    <ng-pass-otp
        class="otp-input text-center"
        (onInputChange)="onOtpChange($event)"
        [config]="config"
    ></ng-pass-otp>
    <mat-card-subtitle class="text-center mt-4"
        >Didn't you get your code yet?</mat-card-subtitle
    >
    <a
        class="cur-point  border-underline"
        (click)="onReSenedCode()"
        ><span translate>pages.login.resendCode</span></a
    >
    <button
        mat-raised-button
        (click)="submit()"
        [disabled]="!canSubmit"
        color="primary"
        type="submit"
        class="d-block mx-auto my-4 py-2 w-100"
    >
        {{ 'pages.login.verify' | translate }}    </button>
    </mat-card>
</div>
<div class="reset-blk" *ngIf="showResetPassword">
     <password-reset-update (closeReset)="closeResetPassword($event)"></password-reset-update>
</div>